import React from "react";
import cx from "classnames";
import { MoonIcon, SunIcon } from "assets";
import { useTailwindTheme } from "shared-hooks";

const ThemeToggle = () => {
  const [, toggleTheme] = useTailwindTheme();

  return (
    <button
      onClick={toggleTheme}
      className={cx(
        "relative flex h-11 w-[88px] items-center rounded-full border-2",
        "border-gray-300/40 bg-gray-200/60 p-1 transition-colors duration-300",
        "dark:border-blue-600/40 dark:bg-indigo-950/80"
      )}
    >
      <div
        className={cx(
          "absolute z-[1] h-8 w-9 translate-x-0 transform rounded-full",
          "bg-blue-600 shadow-md transition-transform duration-300 ease-in-out dark:translate-x-10"
        )}
      />

      <div className="z-[1] flex w-full items-center">
        <div className="ml-2 text-white transition-colors duration-300 dark:text-slate-500">
          <SunIcon width={20} height={20} />
        </div>
        <div className="ml-auto mr-2 text-slate-400 transition-colors duration-300 dark:text-white">
          <MoonIcon width={20} height={20} />
        </div>
      </div>
    </button>
  );
};

export default ThemeToggle;
